import React from 'react';
import useShadowRoot from '@/hooks/useShadowRoot';

export const useKeyboardNavigation = (id: string) => {
  const [_a11yIndex, _setA11yIndex] = React.useState(0);
  const a11yIndexRef = React.useRef(_a11yIndex);
  const setA11yIndex = (v: number) => {
    a11yIndexRef.current = v;
    _setA11yIndex(v);
  };

  const root = useShadowRoot();

  const elements = root?.querySelectorAll(id) as NodeListOf<HTMLElement>;
  const max = elements?.length - 1;
  const min = 0;
  const current = a11yIndexRef.current;

  const onArrowDown = (evt: KeyboardEvent) => {
    evt.preventDefault();
    if (current === max) {
      elements?.[0]?.focus();
      setA11yIndex(0);
    } else {
      const idx = current + 1;
      setA11yIndex(idx);
      elements?.[idx]?.focus();
    }
  };

  const onArrowUp = (evt: KeyboardEvent) => {
    evt.preventDefault();
    if (current === min) {
      setA11yIndex(max);
      elements?.[max]?.focus();
    } else {
      const idx = current - 1;
      setA11yIndex(idx);
      elements?.[idx]?.focus();
    }
  };

  return { onArrowDown, onArrowUp };
};
